import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useState, useRef } from 'react';
import { Button } from '@habitech/call-to-action';
import { EditorWrapper, Text, ErrorText } from './styles';
import { postSeoUrl } from './../../apis/getSeoUrl';
import { useSelector } from 'react-redux';
import { RootState } from './../../redux/RootState';

// Para mas formatos ver: https://quilljs.com/docs/formats/
const modules = {
    toolbar: [[{ header: [2, 3, 4, false] }], ['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
};

const Editor = ({ dataSeo, description }) => {
    const token = useSelector((state: RootState) => state.User.token);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(description);
    const [error, setError] = useState('');
    const quill = useRef(null);

    const handleSave = () => {
        const valueLength = quill.current.getEditor().getLength();
        if (value) {
            setLoading(true);
            const _value = valueLength < 2 ? '' : value;
            postSeoUrl({ ...dataSeo, description: _value }, token).then((res) => {
                if (res.success) {
                    setLoading(false);
                } else {
                    setError('*Error al guardar');
                }
            });
        } else {
            setError('Verifique el texto a guardar');
            setLoading(false);
        }
    };

    return (
        <div>
            <Text>Nota: La descripción que se ve en el editor es tal cual como se muestra en la url especificada.</Text>
            <EditorWrapper>
                <ReactQuill ref={quill} className="description-editor" theme="snow" value={value} onChange={setValue} modules={modules} />
            </EditorWrapper>
            {error && <ErrorText>{error}</ErrorText>}
            <Button dataId="button-search" originType="pcom" size="large" onClick={handleSave} disabled={loading}>
                {loading ? ' Guardando...' : 'Guardar'}
            </Button>
        </div>
    );
};
export default Editor;
